import React from 'react'
import { FETCH_PRODUCTS_FROM_PODIO_BY_FILTER } from '../../../constantTypes/products/ProductConstantTypes';

const ProductsByFilterReducer=(state=[],action)=> {
  switch (action.type) {
      case FETCH_PRODUCTS_FROM_PODIO_BY_FILTER:
          return {
              ...state,filterProducts:action.payload
          }
  
      default:
         return state;
  }
}

export default ProductsByFilterReducer
